import { ThemeOptions } from '@mui/material';

import { typography } from 'themeV5/typography';

import { breakpoints } from './breakpoints';
import components from './components';

const baseThemeOptions: ThemeOptions = {
  typography,
  breakpoints,
  components,
  spacing: (factor: number) => `${0.25 * factor}rem`,
};

export default baseThemeOptions;
